import React from 'react';
import cx from 'classnames';
import { Box, Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useLocation, useRouteMatch } from 'react-router-dom';
import MuiRouterLink from '€components/MuiRouterLink';
import { Routes } from '€lib/routing';
import { useSettingsStyles } from './settingStyles';
import { Hidden } from '€components/Hidden';

interface SettingsRouteOptionProps {
    option: {
        label: string;
        location: Routes | null;
        href: string | null;
    };
}

const SettingsRouteOption: React.FunctionComponent<SettingsRouteOptionProps> = ({ option }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const { pathname } = useLocation();
    const match = useRouteMatch();
    const classes = useSettingsStyles();

    return (
        <>
            <MuiRouterLink
                to={{
                    pathname: `${option.location}`,
                    state: {
                        path: pathname,
                    },
                }}
                underline="none"
            >
                <Box
                    className={cx({
                        [classes.active]: matches && match.path === option.location,
                        [classes.inActive]: match.path !== option.location,
                        [classes.withChevron]: !matches,
                    })}
                    pl={{ xs: 0, sm: 3 }}
                    py={1.5}
                >
                    <Typography variant="subtitle1">{option.label}</Typography>
                    <Hidden smUp>
                        <ChevronRightIcon color="secondary" />
                    </Hidden>
                </Box>
            </MuiRouterLink>
            <Hidden smUp>
                <Divider />
            </Hidden>
        </>
    );
};

export default SettingsRouteOption;
